module.exports = __webpack_public_path__ + "static/media/ciplaImg.18af752d.svg";